import { render, staticRenderFns } from "./table_content_section.vue?vue&type=template&id=853e8b00&scoped=true&"
import script from "./table_content_section.vue?vue&type=script&lang=js&"
export * from "./table_content_section.vue?vue&type=script&lang=js&"
import style0 from "./table_content_section.vue?vue&type=style&index=0&id=853e8b00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853e8b00",
  null
  
)

export default component.exports